import { render, staticRenderFns } from "./ResourceDatail.vue?vue&type=template&id=e851f1ec&scoped=true"
import script from "./ResourceDatail.vue?vue&type=script&lang=js"
export * from "./ResourceDatail.vue?vue&type=script&lang=js"
import style0 from "./ResourceDatail.vue?vue&type=style&index=0&id=e851f1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e851f1ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VBtn,VContainer,VFlex,VFooter})
